import { Button, Input, Loader, Table } from '@scuf/common';
import { formatDate } from 'helpers';
import useFetch from 'helpers/hooks/useFetch';
import i18n from 'i18n';
import { MicrosigaSerialNumber } from 'models/repaircenter/rmaModel';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { REPAIR_CENTER } from 'resources';
import { notificationAtom } from 'resources/atoms/notificationAtom';

function RmaSummary() {
    const { t } = useTranslation(['home', 'common', 'repaircenter', 'notification']);
    const [serial, setSerialNumber] = useState<string>("");
    const setNotification = useSetRecoilState(notificationAtom);
    const [show, showSerialNumber] = useState<boolean>(false);

    const [microsigaItem, consultSerial, loading] = useFetch<string, MicrosigaSerialNumber>({
        url: REPAIR_CENTER.consultSerialNumber,
        method: 'POST',
        onError: 'SerialNumber',
    });

    const handleClick = async () => {
        try {
            await consultSerial(JSON.stringify(serial!), current => {
                if (current.message === 'True') {
                    setNotification(old => ({ ...old, message: 'Conflito de dados', type: 'information' }));
                    return;
                }
                if (current.data === null) {
                    setNotification(old => ({ ...old, type: 'information', message: "NoData" }));
                    return;
                }
                showSerialNumber(!!current.data);
            });
        } catch (error) {
            setNotification(old => ({ ...old, type: 'critical', message: t('SerialError') }));
        }
    };

    function formatDateDescritivo(dateInput: string | undefined, locale: string = 'pt-BR'): string {
        if (!dateInput) return '';

        const date = new Date(dateInput);
        if (isNaN(date.getTime())) return '';

        const dia = date.getDate();
        const mes = date.toLocaleString(locale, { month: 'long' });
        const ano = date.getFullYear();

        const mesFormatado = mes.charAt(0).toUpperCase() + mes.slice(1);

        let connector1 = '';
        let connector2 = '';

        switch (locale) {
            case 'en':
            case 'en-US':
                connector1 = 'of';
                connector2 = '';
                break;
            default:
                connector1 = 'de';
                connector2 = 'de';
        }

        return `${dia} ${connector1} ${mesFormatado} ${connector2} ${ano}`.trim();
    }

    return (
        <>
            <div>
                {
                    <>
                        <div className="form2Columns">
                            <h2>{t('common:actions.Consult')} </h2>
                            <Input
                                placeholder={t('common:translation.SerialNumber')}
                                label={t('common:translation.SerialNumber')}
                                type="text"
                                onChange={sn => setSerialNumber(sn)}
                                value={serial}
                            />
                            <div className="buttonsSearch">
                                <Button
                                    type="primary"
                                    icon="search"
                                    disabled={!serial}
                                    content={t('common:actions.Consult')}
                                    iconPosition="right"
                                    onClick={handleClick}
                                    loading={loading}
                                />
                            </div>
                        </div>
                    </>
                }
            </div>
            {show !== null ? (
                <div>
                    <h4>
                        {t('common:translation.Description')}
                    </h4>
                    <Table>
                        <Table.Header>
                            <Table.HeaderCell content={t('common:translation.SerialNumber')} />
                            <Table.HeaderCell content={t('common:translation.ServiceWarranty')} />
                            <Table.HeaderCell content={t('common:translation.FactoryWarranty')} />
                            <Table.HeaderCell content={t('common:translation.MaintenanceContract')} />
                            <Table.HeaderCell content={t('common:translation.PartNumber')} />
                            <Table.HeaderCell content={t('common:translation.Invoice')} />
                            <Table.HeaderCell content={t('repaircenter:translation.ServiceWarrantyValidity')} />
                            <Table.HeaderCell content={t('repaircenter:translation.FactoryWarrantyValidity')} />
                            <Table.HeaderCell content={t('repaircenter:translation.MaintenanceContractValidity')} />
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell content={microsigaItem?.data?.serialNumber} />
                                <Table.Cell content={microsigaItem?.data?.flagHasServiceWarranty === true ? "SIM" : "NÃO"} />
                                <Table.Cell content={microsigaItem?.data?.flagHasFactoryWarranty === true ? "SIM" : "NÃO"} />
                                <Table.Cell content={microsigaItem?.data?.flagHasContract === true ? "SIM" : "NÃO"} />
                                <Table.Cell content={microsigaItem?.data?.partNumber} />
                                <Table.Cell content={microsigaItem?.data?.salesInvoice} />
                                <Table.Cell content={formatDateDescritivo(microsigaItem?.data?.serviceWarranty, i18n.language)} />
                                <Table.Cell content={formatDateDescritivo(microsigaItem?.data?.factoryWarranty, i18n.language)} />
                                <Table.Cell content={formatDateDescritivo(microsigaItem?.data?.contractValidity, i18n.language)} />
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </div>
            ) : (
                ''
            )}
        </>
    );
}

export default RmaSummary;